import styled from 'styled-components';

export const AppWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const HeaderContainer = styled.div`
  flex-shrink: 0;
  width: 100%;
  z-index: 10;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85px;
  background-color: #fff;
  flex-shrink: 0;
  width: 100%;
  z-index: 10;
  border-top: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
`;

export const ContentContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 16px;
`;
